import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import axios from 'axios';
import Select from 'react-select';
import { Configurations } from '../../Utils/Configurations';

class ModalBaixa extends Component {

    constructor(props) {
        super(props);

        this.onDateChange = this.onDateChange.bind(this);
        this.finalizaBaixa = this.finalizaBaixa.bind(this);
        this.habilitaFinalizarBaixa = this.habilitaFinalizarBaixa.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleValorChange = this.handleValorChange.bind(this);
        this.handleObsChange = this.handleObsChange.bind(this);
        this._outsideRange = this._outsideRange.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            idTipoPagamento: null,
            valorPago: null,
            dtPagto: null,
            obs: '',
            idPagador: this.props.idSolicitante,

            codMembroBusca: '',
            buscaRealizada: false,

            isLoading: false,
            habilitaAlterarVigencia: false,
            habilitaAlterarAssinante: false,
            buscaHabilitada: false,
            alteraVigencia: false,

            date: null
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.opcoesPagamento = [
            { label: "Cartão de crédito", value: 1 },
            { label: "Boleto bancário", value: 2 },
            { label: "PIX", value: 10 },
        ]
    }

    habilitaFinalizarBaixa() {
        return !(!!this.state.idTipoPagamento * !!this.state.valorPago * !!this.state.dtPagto * !!this.state.idPagador)
    }

    finalizaBaixa() {
        const _baixaPgto = {
            "idTipoPagamento": this.state.idTipoPagamento,
            "valorPago": this.state.valorPago,
            "dtPagto": this.state.dtPagto.format(),
            "obs": this.state.obs,
            "idPagador": this.state.idPagador
        }
        axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.idPedido}/pagamento`, _baixaPgto).then(response => {

        }).catch(err => {
            console.log(err);
        }).finally(() => {
            this.props.atualizaPedido();
            this.props.toggle();
        });
    }

    onDateChange(date) { this.setState({ dtPagto: date, alteraVigencia: false }) }

    handleSelectChange(e) { this.setState({ idTipoPagamento: e.value }) }

    handleValorChange(e) { this.setState({ valorPago: e.target.value }) }
    handleObsChange(e) { this.setState({ obs: e.target.value }) }

    _outsideRange(day) {
        return day.toISOString() > moment().add("days", 1).toISOString();
    }

    render() {
        return (
            <div className="row modal-baixa">
                <div className="col-12 py-4 px-3">
                    <div className="row px-3 align-items-center">
                        <div className="col-4">
                            <div className="row">
                                <div className="col-12">
                                    <strong>Data do pagamento</strong>
                                </div>
                                <div className="col-12">
                                    <SingleDatePicker
                                        date={this.state.dtPagto !== null ? moment(this.state.dtPagto) : null} // momentPropTypes.momentObj or null
                                        onDateChange={date => this.onDateChange(date)} // PropTypes.func.isRequired
                                        focused={this.state.focused} // PropTypes.bool
                                        onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                                        id="your_unique_id" // PropTypes.string.isRequired,
                                        orientation="horizontal"
                                        anchorDirection="right"
                                        openDirection="down"
                                        verticalHeight={450}
                                        numberOfMonths={1}
                                        small={true}
                                        phrases={this._phrases}
                                        placeholder=""
                                        isOutsideRange={this._outsideRange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="row">
                                <div className="col-12">
                                    <strong>Valor pago:</strong>
                                </div>
                                <div className="col-12">
                                    <input className="form-control" type="number" value={this.state.valorPago === null ? '' : this.state.valorPago} onChange={this.handleValorChange} />
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="row">
                                <div className="col-12">
                                    <strong>Tipo do pagamento:</strong>
                                </div>
                                <div className="col-12">
                                    <Select
                                        id="ddlStatus"
                                        placeholder="Selecione uma opção"
                                        closeMenuOnSelect={true}
                                        name="opcoesPagamento"
                                        onChange={this.handleSelectChange}
                                        options={this.opcoesPagamento}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 py-3">
                            <div className="row">
                                <div className="col-12">
                                    <strong>Observação:</strong>
                                </div>
                                <div className="col-12">
                                    <textarea id="obs" type="text" className="form-control" name="observacao" value={this.state.obs} onChange={this.handleObsChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-6 text-right">
                            <button onClick={this.props.toggle} className="btn btn-outline-secondary">voltar</button>
                        </div>
                        <div className="col-6 text-left">
                            <button disabled={this.habilitaFinalizarBaixa()} onClick={this.finalizaBaixa} className="btn btn-success">finalizar baixa</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalBaixa;